class WrapgramCartPersonalization {
  constructor() {
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    // Listen for context changes
    window.addEventListener('wrapgram:context-changed', () => this.updateCartDisplay());

    // Update cart on page load
    this.updateCartDisplay();

    // Observe cart for dynamic updates
    this.observeCartChanges();
  }

  // Update all cart items to show device context
  updateCartDisplay() {
    const context = window.WrapgramDeviceContext?.context;
    if (!context || !context.isActive) {
      return;
    }

    const deviceName = window.WrapgramDeviceContext.getDeviceDisplayName();

    // Find cart items (works with most Shopify themes)
    const cartItems = document.querySelectorAll('[data-cart-item], .cart-item, .line-item, [data-line-item]');

    cartItems.forEach((item) => {
      this.updateCartItem(item, deviceName, context);
    });

    // Update cart summary
    this.updateCartSummary(deviceName);
  }

  // Update individual cart item — model info is now rendered by Liquid (wrapgram-cart-model-line)
  updateCartItem(item, _deviceName, context) {
    try {
      item.setAttribute('data-wrapgram-brand', context.brand || '');
      item.setAttribute('data-wrapgram-model', context.model || '');
      item.setAttribute('data-wrapgram-layout', context.layout || 'layout-1');
    } catch (error) {
      console.debug('[Wrapgram] Could not fully update cart item:', error);
    }
  }

  // Update cart summary with device info
  updateCartSummary() {
    try {
      const context = window.WrapgramDeviceContext?.context;
      if (!context || !context.isActive) {
        return;
      }

      const cartSummary = document.querySelector('[data-wrapgram-cart-summary]');
      if (cartSummary) {
        const deviceName = window.WrapgramDeviceContext.getDeviceDisplayName();
        if (deviceName) {
          let summaryText = cartSummary.textContent;
          if (!summaryText.includes('For:')) {
            summaryText += ` - For: ${deviceName}`;
            cartSummary.textContent = summaryText;
          }
        }
      }
    } catch (error) {
      console.error('[Wrapgram] Failed to update cart summary:', error);
    }
  }

  // Observe cart for dynamic changes (e.g., item added via AJAX)
  observeCartChanges() {
    try {
      const cartContainer = document.querySelector('[data-wrapgram-cart]');
      if (!cartContainer) return;

      let debounceTimer = null;
      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => this.updateCartDisplay(), 100);
      });

      observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (error) {
      console.error('[Wrapgram] Failed to observe cart changes:', error);
    }
  }

  // Set device context in cart form (for checkout)
  setCartFormContext() {
    try {
      const context = window.WrapgramDeviceContext?.context;
      if (!context || !context.isActive) {
        return;
      }

      const cartForm = document.querySelector('form[data-wrapgram-cart-form]');
      if (!cartForm) return;

      // Add hidden inputs to form
      const layoutInput = document.createElement('input');
      layoutInput.type = 'hidden';
      layoutInput.name = 'attributes[wrapgram_layout]';
      layoutInput.value = context.layout || 'layout-1';

      const brandInput = document.createElement('input');
      brandInput.type = 'hidden';
      brandInput.name = 'attributes[wrapgram_brand]';
      brandInput.value = context.brand || '';

      const modelInput = document.createElement('input');
      modelInput.type = 'hidden';
      modelInput.name = 'attributes[wrapgram_model]';
      modelInput.value = context.model || '';

      cartForm.appendChild(layoutInput);
      cartForm.appendChild(brandInput);
      cartForm.appendChild(modelInput);
    } catch (error) {
      console.error('[Wrapgram] Failed to set cart form context:', error);
    }
  }

  // Add device context to line items
  addContextToLineItem(lineItemIndex) {
    try {
      const context = window.WrapgramDeviceContext?.context;
      if (!context || !context.isActive) {
        return;
      }

      const lineItem = document.querySelector(`[data-wrapgram-cart-item][data-line-index="${lineItemIndex}"]`);
      if (!lineItem) return;

      // Store context in data attributes
      lineItem.setAttribute('data-wrapgram-brand', context.brand || '');
      lineItem.setAttribute('data-wrapgram-model', context.model || '');
      lineItem.setAttribute('data-wrapgram-layout', context.layout || 'layout-1');
    } catch (error) {
      console.error('[Wrapgram] Failed to add context to line item:', error);
    }
  }
}

// Initialize on load
window.WrapgramCartPersonalization = new WrapgramCartPersonalization();

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.WrapgramCartPersonalization.init();
  });
} else {
  window.WrapgramCartPersonalization.init();
}
